import { Modal } from 'lib/mortar/components/Modal';
import { useEffect, useState } from 'react';
import { Button, Heading, Text } from '@checkatrade/web-ui';
import { track } from 'lib/sdks/analytics';
import Image from 'next/image';

type FeedbackModalProps = {
  stopAndClose: () => void;
};

const yesFeedback = 'Yes, I’d find this useful';
const noFeedback = 'No thanks';

export const FeedbackModal = ({ stopAndClose }: FeedbackModalProps) => {
  const [feedbackGiven, setFeedbackGiven] = useState(false);

  useEffect(() => {
    track('feedback_survey.show');
  }, []);

  const handleSubmitFeedback = (feedback: string) => {
    setFeedbackGiven(true);
    track('feedback_survey.submit', {
      feedback_given: feedback,
    });
  };

  const imageSrc = feedbackGiven
    ? '/static/feedback-illustration-success.svg'
    : '/static/feedback-illustration-clock.svg';

  const subTitle = feedbackGiven
    ? 'Thanks for your feedback!'
    : 'Would saving for later help?';

  const subText = feedbackGiven
    ? 'We’re always working to make posting a job simpler. Your input helps shape what we build next, so it works better for you.'
    : 'We’re exploring new ways to let you finish your job when you’re ready. Tap below to let us know if this is helpful.';

  return (
    <Modal
      name="Save Job Feedback Modal"
      size="small"
      onDismiss={() => {
        track('feedback_survey.close', {
          feedback_given: 'escape key pressed',
        });
        setTimeout(() => {
          stopAndClose();
        }, 1);
      }}
      hideCloseButton
      noPadding
      centered
      closeOnClickOutside
    >
      <div className="flex flex-col items-center justify-center p-6">
        <div className="mb-6 flex size-full justify-center rounded-lg bg-secondary-soft p-10">
          <Image src={imageSrc} width={150} height={150} alt="Feedback image" />
        </div>

        <Heading as="h3" variant="titleLG" className="pb-2 text-center">
          {subTitle}
        </Heading>

        <Text className="text-center">{subText}</Text>

        <div className="flex w-full flex-col gap-2 pt-4">
          {feedbackGiven ? (
            <Button type="submit" size="md" onClick={stopAndClose}>
              Close
            </Button>
          ) : (
            <>
              <Button
                onClick={() => {
                  handleSubmitFeedback(yesFeedback);
                }}
              >
                {yesFeedback}
              </Button>
              <Button
                variant="outline"
                onClick={() => {
                  handleSubmitFeedback(noFeedback);
                }}
              >
                {noFeedback}
              </Button>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};
